import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, ButtonGroup } from '@folio/stripes/components';

const tabsList = [
  {
    tabName: 'defaultScheme',
    tabLabel: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.addFieldsTabs.defaultScheme"
        defaultMessage="Default Scheme"
      />
    ),
  },
  {
    tabName: 'customFields',
    tabLabel: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.addFieldsTabs.customFields"
        defaultMessage="Custom Fields"
      />
    ),
  },
];

const AddFieldsTabs = ({ currentTab, setCurrentTab }) => (
  <ButtonGroup fullWidth>
    {tabsList.map((tab) => (
      <Button
        key={`${tab.tabName}`}
        onClick={() => setCurrentTab(tab.tabName)}
        onMouseDown={(e) => e.preventDefault()}
        buttonStyle={`${currentTab === tab.tabName ? 'primary' : 'default'}`}
        aria-selected={currentTab === tab.tabName}
        id={`inventory-templates-addFieldsTabs-${tab.tabName}`}
      >
        {tab.tabLabel}
      </Button>
    ))}
  </ButtonGroup>
);

AddFieldsTabs.propTypes = {
  currentTab: PropTypes.string,
  setCurrentTab: PropTypes.func,
};

export default AddFieldsTabs;
